import React from "react";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  // Height comes from .auth-layout's min-height (not vh-100): a fixed 100vh
  // shell clipped company lists taller than a phone viewport with no way to
  // scroll (ZC-5901).
  return (
    <div className="auth-layout d-flex">
      <div className="auth-layout__left d-none d-lg-flex flex-column justify-content-center align-items-center p-5">
        <div className="auth-layout__brand text-center">
          <img
            src="https://cdn.zenglobal.au/logo/powered-by-zen-login.jpg"
            alt="Powered by Zen"
            className="auth-layout__logo img-fluid mb-4"
          />
          <h2 className="text-white fw-semibold mb-2">Welcome back</h2>
          <p className="auth-layout__tagline mb-0">
            Sign in to manage your business
          </p>
        </div>
      </div>

      <div className="auth-layout__right d-flex flex-column justify-content-center align-items-center flex-grow-1 p-4 bg-white">
        <div className="auth-layout__form-container w-100">
          <div className="d-flex justify-content-center mb-4 d-lg-none">
            <img
              src="https://cdn.zenglobal.au/logo/powered-by-zen-login.jpg"
              alt="Powered by Zen"
              className="img-fluid auth-layout__logo--mobile"
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
